import {
  AdCampaignMediaTypeEnum,
  MediaPromoUploadMutation,
  SourcefileType,
  useMediaPromoUploadMutation,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';
import { FetchResult } from '@apollo/client';

export type PromoUploadStatusType = {
  file?: File;
  time?: string;
  id?: string;
  promoId?: string;
  promoAdId?: string;
  title: string;
  filename?: string;
  isLoading: boolean;
  error?: Error;
  duration?: number;
  type?: number;
  playDuration?: number;
  videoPromoId?: string;
  withSound?: boolean;
  performerTitle?: string;
  previewUrl?: string | null;
  sourcefiles: Partial<SourcefileType>[];
};

export type UsePromoUploadResultType = BaseMutationResultType;

export type UsePromoUploadType = {
  result: UsePromoUploadResultType;
  uploadPromo: (file: File, mediaType?: AdCampaignMediaTypeEnum) => Promise<FetchResult<MediaPromoUploadMutation>>;
};

const usePromoUpload = (): UsePromoUploadType => {
  const [promoUploadMutation, promoUploadMutationResult] = useMediaPromoUploadMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const uploadPromo = async (file: File, mediaType?: AdCampaignMediaTypeEnum) =>
    promoUploadMutation({
      variables: {
        input: { file, mediaType },
      },
    });

  const result: UsePromoUploadResultType = {
    error: promoUploadMutationResult.error,
    loading: promoUploadMutationResult.loading,
    called: promoUploadMutationResult.called,
  };

  return {
    result,
    uploadPromo,
  };
};

export default usePromoUpload;
